<template>
    <Header></Header>

    <div class="container sub_page _report">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/report_left_01.png" /></i>
                <i class="deco_02 spin_blink1 _small"><img src="img/b_icon_03.png" /></i>
                <i class="deco_03 blink_zoom1 _xxsmall"><img src="img/b_icon_04.png" /></i>
                <i class="deco_04 blink_blink4 _xxxsmall"><img src="img/b_icon_04.png" /></i>
                <i class="deco_05 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>

                <i class="deco_character"><img src="img/report_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민제보창</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">성매매 의심 업소 제보</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">성매매 알선 광고 제보</a></li>
                </ul>
            </div>
        </section>

        <Area v-if="state.tab === 1"></Area>
        <Ad v-if="state.tab === 2"></Ad>
    </div>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import { Header, Footer, reactive, globalStore, onMounted, watch, Area, Ad, useRoute, router } from "@/BaseComponent";

    export default {
        components: { Header, Footer, Area, Ad },
        setup() {
            const global = globalStore();
            const route = useRoute();
            const state = reactive({
                tab: 0 as number,
                subMenuOpen: false as boolean,
                subMenuName: "성매매 의심 업소 제보" as string,
            });

            onMounted(() => {
                const type = Number(route.query.type);
                if (route.query.type) {
                    if (type && typeof type === "number" && !isNaN(type)) {
                        changeTab(type);
                    } else {
                        state.tab = 1;
                    }
                } else {
                    state.tab = 1;
                }
            });

            watch(
                () => route.query.type,
                () => {
                    const type = Number(route.query.type);
                    if (route.query.type) {
                        if (type && typeof type === "number" && !isNaN(type)) {
                            changeTab(type);
                        } else {
                            state.tab = 1;
                        }
                    } else {
                        state.tab = 1;
                    }
                },
            );

            const changeTab = (tab: number) => {
                state.tab = tab;
                router.push({ path: "/report", query: { type: state.tab } });
                if (global.reportTab !== state.tab) global.setReportTab(state.tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "성매매 의심 업소 제보";
                        break;
                    case 2:
                        state.subMenuName = "성매매 알선 광고 제보";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            return { state, changeTab, subMenuTab };
        },
    };
</script>
